import React from 'react'
import { useTranslation } from 'react-i18next'
// useTranslation é um hook 
// que devolve uma função de tradução (t) e a instância do i18n

const I18n = ({childToParent, linguagem, theme}) => {
  const { i18n } = useTranslation()
  // Instância do i18n

  function handleChangeLanguage(language) {
    // Trocando o idioma na chamada da função
    i18n.changeLanguage(language);
    if(language == 'en-US')
        childToParent("en");
    else if(language == 'pt-BR')
        childToParent("pt")

  }

  const selectedLanguage = i18n.language // Idioma selecionado
  return (
    <div style={{maxWidth: "40px"}}>
        <div className="lang-menu">
            <div className={theme === "dark" ? "selected-lang " + linguagem + " inverter" : "selected-lang " + linguagem}>
            
            </div>
            <ul>
                <li>
                    <a onClick={() => handleChangeLanguage('en-US')} href="#" className="en">English</a>
                </li> 
                <li>
                    <a onClick={() => handleChangeLanguage('pt-BR')} href="#" className="pt">Português</a>
                </li>
            </ul>
        </div>  
    </div>
  )
}

export default I18n